import React from "react";

import useErrorAlert from "../hooks/useErrorAlert";
import webappPlatformApi from "./webappPlatformApi";

function WebappPlatformApiWrapper({ children }: { children: React.ReactNode }) {
  const showErrorAlert = useErrorAlert();
  const [inited, setInited] = React.useState(false);

  React.useEffect(() => {
    if (inited) return;

    webappPlatformApi
      .init()
      .then(() => setInited(true))
      .catch(() => showErrorAlert(undefined, true));
  }, [inited, setInited, showErrorAlert]);

  return <>{inited && children}</>;
}

export default WebappPlatformApiWrapper;
